import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {showOnReviewState} from 'app/review/hocs/showOnReviewState';
import {gt} from 'app/utils/i18n';

import type {ShowOnReviewStateInjectedProps} from 'app/review/hocs/showOnReviewState';

function RawDocNeedsReviewBadge(props: ShowOnReviewStateInjectedProps) {
  const {reviewDateState} = props;

  return (
    <LazyTooltip tooltip={gt('Document requires review')}>
      <span
        className={`ml-1 badge badge-${
          reviewDateState === 'overdue' ? 'danger' : 'warning'
        }`}
      >
        <i className="fa fa-certificate" /> {gt('Needs review')}
      </span>
    </LazyTooltip>
  );
}

export const DocNeedsReviewBadge = showOnReviewState([
  'overdue',
  'reminder_time',
])(RawDocNeedsReviewBadge);
